import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import Sidebar from './Sidebar'
import Logo from '~/assets/new_gofind/logoMap.svg'

const styles = () => ({
  areaLogo: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    zIndex: 99,
    position: 'absolute',
    bottom: 8,
    right: 8
  },
  text: {
    fontSize: 12,
    fontWeight: 500,
    color: '#000'
  },
  logo: {
    width: 80,
    marginLeft: 8
  }
})

function Desktop({ classes, children, view, message, config, position }) {
  return (
    <div className={classes.wrapper}>
      <a
        target="_blank"
        className={classes.areaLogo}
        rel="noopener noreferrer"
        href="https://www.gofind.online/pertinhodemim?utm_source=Pertinhodemim%20Logo&utm_medium=mapa&utm_campaign=logo%20map"
      >
        <Typography variant="caption" className={classes.text}>
          Powered by
        </Typography>
        <img src={Logo} className={classes.logo} />
      </a>
      <Sidebar message={message} view={view} config={config} position={position}>
        {children}
      </Sidebar>
    </div>
  )
}

export default compose(
  withStyles(styles),
  connect((state) => ({ config: state.config }))
)(Desktop)
